import { Link } from "react-router-dom";

export default function ErrorTesting() {
  throw Error("Oops an error occured");
  return (
    <section>
      <h1>Something went wrong</h1>
      <Link to="/">Home</Link>
    </section>)
}
